import { render, staticRenderFns } from "./Integer.vue?vue&type=template&id=2e28a0e2&scoped=true"
import script from "./Integer.vue?vue&type=script&lang=js"
export * from "./Integer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e28a0e2",
  null
  
)

export default component.exports